import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import InstaPostCard from './InstaPostCard'
import * as _ from 'lodash'

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: ${props => props.fewElts ? 'flex-start' : 'space-between'};
  overflow: auto;
  background-color: #eff4f7;
  ::-webkit-scrollbar {
      width: 12px;
  }
  ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
      border-radius: 10px;
      background-color: white;
  }
  ::-webkit-scrollbar-thumb {
      border-radius: 15px;
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.15);
  }
`

class Posts extends Component {

  onTagProducts = (post) => {
    return (e) => {
      e.preventDefault()
      this.props.onTagProducts(post)
    }
  }

  onChangeVisible = (post) => {
    return () => {
      this.props.onChangePostVisible(post)
    }
  }

  renderPost = (post, i) => {
    const { productsDict, onChangePostVisible } = this.props
    const productsTaggedAmount = _.sumBy(post.products, p => p.info ? 1 : 0)
    return (
      <InstaPostCard
        productsDict={productsDict}
        key={post.id}
        onClick={this.onTagProducts(post)}
        post={post}
        productsTaggedAmount={productsTaggedAmount}
        onChangeVisible={onChangePostVisible(post)}
      />
    )
  }

  render () {
    const { posts } = this.props
    return (
      <Container fewElts={posts.length < 5}>
        {_.map(posts, this.renderPost)}
      </Container>
    )
  }
}

Posts.defaultProps = {
  productsDict: {}
}

Posts.propTypes = {
  productsDict: PropTypes.object,
  posts: PropTypes.array.isRequired,
  onTagProducts: PropTypes.func.isRequired,
  onChangePostVisible: PropTypes.func.isRequired
}

export default Posts



// WEBPACK FOOTER //
// ./src/components/editor/insta/instaTagPosts/Posts.js